/**
 * Home banner promoting the anti-cheat policy at /policy/anti-cheat.
 *
 * Visual rhythm matches the other home banners so the swap when admin
 * flips the flag is a clean silhouette swap. Palette leans on the
 * violet + teal "trust" pair — deliberately distinct from the gold /
 * pink commercial banners so at a glance the user reads "policy, not
 * promo".
 */

export function antiCheatBannerHtml() {
  return `
    <div
      class="card anti-cheat-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#15233F 0%,#5B2C91 100%);border-color:rgba(43,179,155,0.55);"
    >
      <a href="/policy/anti-cheat" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:#5EE0C6;flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
               stroke-linejoin="round" aria-hidden="true" style="display:block;">
            <!-- Shield with a check inside: fair-play mark -->
            <path d="M12 2 4 5v6c0 5 3.5 8.5 8 11 4.5-2.5 8-6 8-11V5l-8-3z"/>
            <path d="m9 12 2 2 4-4"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            We reward excellence, not cheats
          </div>
          <div style="color:rgba(255,255,255,0.78);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            How we protect your prize pool
          </div>
        </div>
        <span
          class="btn sm"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;background:rgba(43,179,155,0.22);border:1px solid rgba(43,179,155,0.55);color:#fff;font-weight:700;"
        >
          Know more
        </span>
      </a>
    </div>
  `;
}
